import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { Stack, Typography, useTheme } from '@mui/material';
import { Socket } from 'socket.io-client';
import { WhosOnline } from '@par/shared/common/types';

type PropTypes = {
  activePlayers: string[];
  close: () => void;
  open: boolean;
  socket: Socket;
};

export const PlayerStatusesDialog = ({
  activePlayers,
  close,
  open,
  socket,
}: PropTypes) => {
  const theme = useTheme();
  const [playerStatuses, setPlayerStatuses] = useState<WhosOnline[]>();

  useEffect(() => {
    if (!open) return;
    socket.emit('playerStatuses', { activePlayers }, (res: any) => {
      setPlayerStatuses(res);
    });
  }, [open]);

  return (
    <Dialog open={open} onClose={close} maxWidth="md">
      <DialogContent>
        <Stack spacing={4}>
          {playerStatuses &&
            playerStatuses.map((p) => (
              <Stack>
                <Typography variant="h6" fontWeight={600}>
                  {p.username}
                </Typography>
                <>
                  {Object.keys(p)?.map((key) => (
                    <Typography variant="caption">
                      {key}: <strong>{JSON.stringify(p[key])}</strong>
                    </Typography>
                  ))}
                </>
              </Stack>
            ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={close} fullWidth>
          DISMISS
        </Button>
      </DialogActions>
    </Dialog>
  );
};
